module.exports = __webpack_public_path__ + "static/Macbook-851939b2dd11c48b7e8423f7c6cce5ec.png";